export const sleep = (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export const waitForNextPaint = () =>
  new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(resolve);
    });
  });

export const getChartInstance = (chartRef) => {
  const chartRefValue = chartRef && chartRef.current;

  if (!chartRefValue) return null;
  if (chartRefValue.chartInstance) return chartRefValue.chartInstance;
  if (typeof chartRefValue.getChart === "function") return chartRefValue.getChart();
  if (typeof chartRefValue.toBase64Image === "function") return chartRefValue;

  return null;
};

export const captureChartImage = async ({
  chartRef,
  getCanvas,
  maxAttempts = 30,
  delayMs = 200,
  minImageLength = 1000,
}) => {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    let chartImage = null;

    const canvasElement = typeof getCanvas === "function" ? getCanvas() : null;
    if (canvasElement && typeof canvasElement.toDataURL === "function") {
      chartImage = canvasElement.toDataURL("image/png");
    }

    if ((!chartImage || chartImage.length < minImageLength) && chartRef) {
      const chartInstance = getChartInstance(chartRef);
      if (chartInstance && typeof chartInstance.toBase64Image === "function") {
        chartImage = chartInstance.toBase64Image();
      }
    }

    if (chartImage && chartImage.length >= minImageLength) {
      return chartImage;
    }

    await waitForNextPaint();
    if (attempt < maxAttempts - 1) {
      await sleep(delayMs);
    }
  }

  return null;
};
